export const sanitizeForFirebase = obj => {
  if (Array.isArray(obj)) {
    return obj.map(item => sanitizeForFirebase(item));
  }

  if (obj !== null && typeof obj === 'object') {
    const sanitized = {};
    for (const key in obj) {
      const value = obj[key];
      sanitized[key] = value === undefined ? null : sanitizeForFirebase(value);
    }
    return sanitized;
  }

  return obj;
};
